import { Result, ResultProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'components/button';

interface GenericResultProps extends ResultProps {
  defaultTo?: string;
  defaultLabel?: string;
  hideDefaultExtra?: boolean;
  content?: JSX.Element;
}

export const GenericResult = ({
  defaultLabel,
  defaultTo = '/home',
  hideDefaultExtra,
  content,
  ...others
}: GenericResultProps): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Result
      title={t('common.error.generic')}
      extra={
        !hideDefaultExtra &&
        defaultTo && [
          content,
          <PrimaryButton key="goBack" onClick={() => navigate(defaultTo)}>
            {defaultLabel || t('common.error.returnHome')}
          </PrimaryButton>,
        ]
      }
      {...others}
    />
  );
};
